export type UserRole = 'admin' | 'ott' | 'pcc' | 'site_worker'

export type CurrentUser = {
  id: number
  email: string
  first_name: string | null
  last_name: string | null
  full_name: string
  role: UserRole
  active: boolean
}

export const isSiteWorker = (user: CurrentUser | null | undefined) =>
  user?.role === 'site_worker'
